<template>
  <div>
    <v-container>
      <!-- Filter -->
      <v-row>
        <v-col cols="12" lg="6" md="6" sm="12" xs="12" class="text-left">
          <v-btn @click="openDrawer = !openDrawer" class="ml-2" small color="#eee">
            <v-icon small>mdi-filter</v-icon>
          </v-btn>
          <v-btn @click="clearFilter(false);$refreshDataTable()" class="ml-2" small color="#eee">
            <v-icon small>mdi-refresh</v-icon>
          </v-btn>
          <div v-if="filterBadge.length > 0" style="display:inline-block">
            <v-chip small class="ml-2" v-for="(text, index) in filterBadge" :key="index">{{text}}</v-chip>
          </div>
          <v-btn color="primary" class="ml-2" style="float: right" @click="exportData" small>Export</v-btn>
        </v-col>
        <popup-drawer :value.sync="openDrawer" :openDrawer="openDrawer">
          <v-col cols="12">
            <v-menu
              v-model="fromDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filter.from_date"
                  label="From Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filter.from_date"
                @input="fromDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12">
            <v-menu
              v-model="toDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filter.to_date"
                  label="To Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filter.to_date"
                @input="toDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn @click="filterData" class="mt-4" color="primary" small>Filter</v-btn>
            <v-btn @click="clearFilter" class="mt-4 ml-2" small>Clear</v-btn>
          </v-col>
        </popup-drawer>
      </v-row>
      <!-- Datatable & Bar Chart -->
      <v-row>
        <v-col cols="12" md="6" sm="6" xs="12">
          <datatable
          ref="muaDatatable"
          :tableOption="tableOption"
          @requestCallBack="loadData"
          />
        </v-col>
        <v-col cols="12" md="6" sm="6" xs="12">
          <bar-chart :chartData='barChartData' :options='barChartOptions' :styles="customStyles"></bar-chart>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import BarChart from '@/components/barChart.vue'
import datatable from '@/components/datatable.vue'
export default {
  name: 'MachineUsageAnalysis',
  mounted () {},
  components: {
    BarChart,
    datatable
  },
  computed: {
    customStyles () {
      return {
        height: '400px',
        position: 'relative'
      }
    },
    filterBadge () {
      const fList = []
      Object.keys(this.filterDisplay).map((x, i) => {
        if (typeof this.filterDisplay[x] === 'object') {
          fList.push(this.filterDisplay[x].text)
        } else if (this.filterDisplay[x]) {
          fList.push(this.filterDisplay[x])
        }
      })
      return fList
    }
  },
  created () {},
  data: function () {
    return {
      barChartOptions: {},
      barChartData: {},
      tableOption: {
        url: 'muaReport',
        moduleName: 'mua_report',
        showSelect: false,
        headers: [
          { text: 'Machine ID', value: 'serial_no' },
          { text: 'Total Runtime(hrs)', value: 'run_time', align: 'center' },
          { text: 'Runtime @less than 60% Duty(hrs)', value: 'sixty_duty', align: 'center' },
          { text: 'Runtime @60% - 90% Duty(hrs)', value: 'less_than_hun_duty', align: 'center' },
          { text: 'Runtime @greater than(hrs)', value: 'hundred_duty', align: 'center' },
        ]
      },
      filterColumn: {
        from_date: { format: '' },
        to_date: { format: '' }
      },
      openDrawer: false,
      filter: {
        from_date: '',
        to_date: '',
      },
      filterDisplay: {},
      fromDateMenu: false,
      toDateMenu: false
    }
  },
  methods: {
    loadData (data, columnTotal) {
      if (data) {
        const label = []
        const sixtyDuty = []
        const lessHundredDuty = []
        const hundredDuty = []

        data.forEach((v, ind) => {
          label.push(v.serial_no)
          sixtyDuty.push(v.sixty_duty)
          lessHundredDuty.push(v.less_than_hun_duty)
          hundredDuty.push(v.hundred_duty)
        })

        // remove 'total' label
        label.pop()

        this.barChartData = {
          labels: label,
          datasets: [{
            label: 'Runtime @less than 60% Duty',
            backgroundColor: '#ED7E30',
            data: sixtyDuty
          },
          {
            label: 'Runtime @60% - 90% Duty',
            backgroundColor: '#A5A5A5',
            data: lessHundredDuty
          },
          {
            label: 'Runtime @greater than',
            backgroundColor: '#F5C104',
            data: hundredDuty
          }]
        }
        this.barChartOptions = { responsive: true, maintainAspectRatio: false }
      }
    },
    filterData () {
      this.$eventBus.$emit('$filterDataTable', this.filter)
      this.openDrawer = false
      this.filterDisplay = this.filter ? JSON.parse(JSON.stringify(this.filter)) : {}
    },
    clearFilter (callEmit = true) {
      if (callEmit) {
        this.$eventBus.$emit('$filterDataTable', {})
      }
      this.openDrawer = false
      this.filter = {}
      this.filterDisplay = {}
    },
    exportData () {
      this.$axios.post('muaReport', { dataTableConfig: this.$refs.muaDatatable.dataTableOptions, dataTableFilter: this.$refs.muaDatatable.dataTableFilter, isExport: true }).then((res) => {
        if (Object.prototype.hasOwnProperty.call(res.data, 'redirect') && Object.prototype.hasOwnProperty.call(res.data.redirect, 'file')) {
          this.downloadFile({
            fileUrl: 'downloadFile/' + res.data.redirect.file,
            name: res.data.redirect.file
          })
        } else {
          this.$eventBus.$emit('$globalSnackbar', 'red', 'Some error in export')
        }
      }).catch((err) => {
        this.loading = false
        if (err.response.status === 422) {
          this.error = err.response.data.error_data
        } else {
          this.$eventBus.$emit('$globalSnackbar', 'red', err.response.data.error_description)
        }
      })
    },
    downloadFile (config = {}) {
      if (config.fileUrl) {
        this.$axios.get(config.fileUrl, { responseType: 'blob' }).then((res) => {
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(new Blob([res.data]))
          link.setAttribute('download', config.name)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          this.$eventBus.$emit('$globalSnackbar', 'success', 'exported successfully!!')
        }).catch((err) => {
          console.log(err)
          this.$eventBus.$emit('$globalSnackbar', 'red', 'Some error in export')
        })
      }
    }
  }
}
</script>
